/**
 *
 * Asynchronously loads the component for Label
 *
 */

import { lazyLoad } from 'utils/loadable';

export const InputLabel = lazyLoad(
  () => import('./index'),
  module => module.InputLabel,
);
